import styled from "styled-components";

const Col = styled.div`
  width: 25%;

  @media (max-width: 575px) {
    width: 33%;
    margin-top: 0;
  }
`;
export default Col;